/* Scented Breeze buy box. Offer = the dev's bundle (custom.bundle_discounts / custom.bundle_content, a colour per fan).
   Cart = same as the coded listicles (page.spin360-*-five-reasons): POST /cart/add.js, then "cart:open" for the store's
   v2 cart drawer; no drawer or a failed add -> the Shopify cart permalink with the same items. Header cart icon shows
   the live count. No dependencies. */
(function () {
  var root = document.getElementById('sb-buy');
  if (!root) return;
  var D = JSON.parse(root.querySelector('[data-bb-data]').textContent);
  var rules = {}; D.rules.forEach(function (r) { rules[r.qty] = r; });
  var qty = D.rules[0].qty, sel = { 1: 'white' };
  var cards = root.querySelector('[data-bb-cards]'), cfg = root.querySelector('[data-bb-cfg]');
  var atc = root.querySelector('[data-bb-atc]'), msg = root.querySelector('[data-bb-msg]'), saveEl = root.querySelector('[data-bb-save]');
  var sumEl = root.querySelector('[data-bb-sum]');

  function money(c) {   // fan-bundle.js: floor to whole dollars, no decimals
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(Math.floor(c / 100));
  }
  function total(q) {   // multi-fan bundles are charged in whole dollars by the cart ($479.00 for 3), so show that
    var t = rules[q].discountPrice * q;
    return q > 1 ? Math.round(t / 100) * 100 : t;
  }
  function label() { atc.textContent = 'Add to Cart - ' + money(total(qty)); summary(); }
  function summary() {   // "2 Fans · 1 White Pearl, 1 Black Pearl"
    if (!sumEl) return;
    var n = { white: 0, black: 0 };
    for (var i = 1; i <= qty; i++) n[sel[i] || 'white']++;
    var parts = ['white', 'black'].filter(function (c) { return n[c]; }).map(function (c) { return (qty > 1 ? n[c] + ' ' : '') + D.swatch[c][1]; });
    sumEl.innerHTML = '<b>' + qty + ' ' + (qty > 1 ? 'Fans' : 'Fan') + '</b> · ' + parts.join(', ');
  }

  // radio groups: click + arrow keys
  function radios(group, onPick) {
    group.addEventListener('click', function (e) { var b = e.target.closest('[role="radio"]'); if (b && group.contains(b)) onPick(b); });
    group.addEventListener('keydown', function (e) {
      var k = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
      if (!k) return;
      var all = [].slice.call(group.querySelectorAll('[role="radio"]')), i = all.indexOf(document.activeElement);
      if (i < 0) return;
      var n = all[(i + k + all.length) % all.length]; onPick(n); n.focus(); e.preventDefault();
    });
  }
  function mark(group, on) {
    group.querySelectorAll('[role="radio"]').forEach(function (b) {
      var y = b === on; b.classList.toggle('is-on', y); b.setAttribute('aria-checked', y ? 'true' : 'false'); b.tabIndex = y ? 0 : -1;
    });
  }

  function row(i) {
    var c = sel[i] || 'white', h = '';
    ['white', 'black'].forEach(function (k) {
      var on = k === c;
      h += '<button type="button" class="bb-sw' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" tabindex="' + (on ? 0 : -1) + '" data-color="' + k + '">' +
        '<img src="' + D.swatch[k][0] + '" width="110" height="120" alt="" loading="lazy"><span>' + D.swatch[k][1] + '</span></button>';
    });
    return '<div class="bb-cfg-row" data-index="' + i + '"><p class="bb-label" id="bb-c' + i + '">Choose color for Fan ' + i + '</p>' +
      '<div class="bb-sws" role="radiogroup" aria-labelledby="bb-c' + i + '">' + h + '</div></div>';
  }
  function renderCfg() {
    var h = ''; for (var i = 1; i <= qty; i++) { if (!sel[i]) sel[i] = 'white'; h += row(i); }
    cfg.innerHTML = h;
    cfg.querySelectorAll('.bb-sws').forEach(function (g) {
      radios(g, function (b) {
        var i = b.closest('.bb-cfg-row').dataset.index;
        sel[i] = b.dataset.color; mark(g, b); showColor(b.dataset.color); summary();
      });
    });
  }
  function setQty(q) {
    qty = q;
    mark(cards, cards.querySelector('[data-qty="' + q + '"]'));
    if (saveEl) saveEl.textContent = 'Save ' + Math.round(100 - total(q) * 100 / (D.compare * q)) + '%';   // true % vs $299 each (the metafield's % is off)
    label(); renderCfg();
  }
  radios(cards, function (b) { setQty(parseInt(b.dataset.qty, 10)); });

  // gallery: native scroll-snap, arrows, counter, thumbnails
  var track = root.querySelector('[data-bb-track]'), slides = [].slice.call(track.children);
  var thumbs = [].slice.call(root.querySelectorAll('.bb-thumb')), nEl = root.querySelector('[data-bb-n]');
  root.querySelector('[data-bb-total]').textContent = slides.length;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function cur() { return Math.round(track.scrollLeft / track.clientWidth); }
  function go(i) { i = (i + slides.length) % slides.length; track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
  var raf;
  track.addEventListener('scroll', function () {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      var i = cur(); nEl.textContent = i + 1;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    });
  }, { passive: true });
  root.querySelector('[data-bb-prev]').addEventListener('click', function () { go(cur() - 1); });
  root.querySelector('[data-bb-next]').addEventListener('click', function () { go(cur() + 1); });
  track.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { go(cur() + 1); e.preventDefault(); }
    if (e.key === 'ArrowLeft') { go(cur() - 1); e.preventDefault(); }
  });
  thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.go, 10)); }); });
  function showColor(c) {   // dev box: slide the gallery to the colour's photo
    var id = String(D.colorMedia[c]);
    for (var i = 0; i < slides.length; i++) if (slides[i].dataset.media === id) { go(i); return; }
  }

  // add to cart: one line per variant (like fan-bundle.js), sent the way the coded listicles send it
  function lines() {
    var map = {}, order = [];
    for (var i = 1; i <= qty; i++) {
      var id = D.variants[sel[i] || 'white'];
      if (!map[id]) { map[id] = { id: +id, quantity: 0 }; order.push(id); }
      map[id].quantity++;
    }
    return order.map(function (k) { return map[k]; });
  }
  function permalink(items) {
    return (D.preview ? 'https://spin360fan.com' : '') + '/cart/' + items.map(function (x) { return x.id + ':' + x.quantity; }).join(',');
  }
  function hasDrawer() { return !!document.getElementById('v2-cart-drawer'); }
  atc.addEventListener('click', function () {
    var items = lines();
    msg.textContent = ''; msg.classList.remove('is-err');
    if (D.preview) {   // local preview: no store cart here
      msg.innerHTML = 'Preview: on the store this posts ' + JSON.stringify({ items: items }) + ' to /cart/add.js and opens the cart drawer. <a href="' + permalink(items) + '" target="_blank" rel="noopener">Open this cart on spin360fan.com</a>';
      return;
    }
    if (!hasDrawer()) { window.location.href = permalink(items); return; }
    atc.disabled = true; atc.setAttribute('aria-busy', 'true'); atc.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () { document.dispatchEvent(new CustomEvent('cart:open')); sel = { 1: 'white' }; setQty(D.rules[0].qty); })
      .catch(function () { window.location.href = permalink(items); })
      .then(function () { atc.disabled = false; atc.removeAttribute('aria-busy'); label(); });
  });

  // header cart icon: shown when the store drawer is on the page, with the current count (as on the listicles)
  function cartIcon() {
    var b = document.querySelector('.sb-cartbtn');
    if (!b || !hasDrawer()) return;
    b.hidden = false;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-v2-cart-count]').forEach(function (e) { e.textContent = c.item_count; e.hidden = !c.item_count; });
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cartIcon); else cartIcon();

  mark(cards, cards.querySelector('.is-on') || cards.querySelector('[role="radio"]'));
  renderCfg(); summary();
})();
